import { render, staticRenderFns } from "./settlementEdit.vue?vue&type=template&id=5c8d5c8e&scoped=true&"
import script from "./settlementEdit.vue?vue&type=script&lang=js&"
export * from "./settlementEdit.vue?vue&type=script&lang=js&"
import style0 from "./settlementEdit.vue?vue&type=style&index=0&id=5c8d5c8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8d5c8e",
  null
  
)

export default component.exports